<template>
  <form autocomplete="off"
        novalidate
        class="mb-2"
        @submit.prevent="addGemeos">
    <div class="headerTitleB2 mt-2 mb-3">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="headerTitleB2_title">
          Gêmeos
        </h4>
      </div>
    </div>
    <div class="form-group px-2">
      <div class="d-inline-block w-100">
        <label class="label"
               for="confirmGemeosSim">Possui Gêmeos?</label>
      </div>
      <span class="custom-control custom-radio custom-control-inline">
        <input id="confirmGemeosSim"
               v-model="gemeos.valid"
               class="custom-control-input input-gemeos"
               checked
               name="confirmGemeos"
               type="radio"
               :value="1"
               @change="changeGemeosOpt">
        <label class="custom-control-label"
               for="confirmGemeosSim">Sim</label>
      </span>

      <span class="custom-control custom-radio custom-control-inline">
        <input id="confirmGemeosNao"
               v-model="gemeos.valid"
               class="custom-control-input input-gemeos"
               name="confirmGemeos"
               type="radio"
               :value="0"
               @change="changeGemeosOpt">
        <label class="custom-control-label"
               for="confirmGemeosNao">Não</label>
      </span>
    </div>

    <div v-if="gemeos.valid"
         class="row mb-3">
      <div class="col-12">
        <label class="label"
               for="ordem_nascimento_registrado">
          Ordem de Nascimento do Registrado
        </label>
      </div>
      <div class="col-2">
        <input id="ordem_nascimento_registrado"
               v-model="ordem_nascimento_registrado"
               v-validate="{required : !propGemeosCrc && !!gemeos.valid}"
               :min="1"
               name="ordem_nascimento_registrado"
               :class="{ 'is-invalid': errors.has('ordem_nascimento_registrado') }"
               :required="!propGemeosCrc && !!gemeos.valid"
               type="number"
               class="form-control form-control-sm"
               @blur="changeOrdemNascimento">
        <small v-if="errors.has('ordem_nascimento_registrado')"
               class="invalid-feedback">{{ errors.first('ordem_nascimento_registrado') }}</small>
      </div>
    </div>

    <FormGemeos v-if="showModal"
                :prop-matricula="propMatricula"
                :prop-data="sendData"
                :prop-show-modal="showModal"
                :prop-gemeos="gemeos"
                :prop-lista="lista"
                @hideModal="modalChanged()"
                @addGemeos="getDados"
                @updateGemeo="getDados" />

    <div v-if="lista.length"
         class="mt-2">
      <div v-for="(gemeo, ind) in lista"
           :key="ind"
           class="boxGemeos d-inline-block w-100 mb-3">
        <div class="boxGemeos_header">
          <h4 class="boxGemeos_header_title px-3 py-2">
            {{ gemeo.nome }}
          </h4>
        </div>

        <div class="boxGemeos_body d-flex align-items-center justify-content-between px-3 my-2">
          <div class="col-9 d-inline-flex justify-content-between m-0 p-0">
            <div class="col-3 m-0 p-0">
              <ul class="boxGemeos_list d-inline-block mr-5">
                <li class="boxGemeos_list_item boxGemeos_list_title ">
                  Ordem de Nascimento
                </li>

                <li class="boxGemeos_list_item">
                  <strong>
                    {{ gemeo.ordem_nascimento }}
                  </strong>
                </li>
              </ul>
            </div>

            <div class="col-2 m-0 p-0">
              <ul class="boxGemeos_list d-inline-block mr-5">
                <li class="boxGemeos_list_item boxGemeos_list_title">
                  Sexo
                </li>

                <li class="boxGemeos_list_item capitalize">
                  <strong>
                    {{ gemeo.sexo ? sexos[gemeo.sexo] : 'Não declarado' }}
                  </strong>
                </li>
              </ul>
            </div>

            <div class="col-4 m-0 p-0">
              <ul class="boxGemeos_list d-inline-block mr-5">
                <li class="boxGemeos_list_item boxGemeos_list_title">
                  Nº Declaração de Nascido Vivo
                </li>

                <li class="boxGemeos_list_item capitalize">
                  <strong>
                    {{ gemeo.numero_declaracao_nascido_vivo ? maskDnv(gemeo.numero_declaracao_nascido_vivo) : 'Não declarado' }}
                  </strong>
                </li>
              </ul>
            </div>

            <div class="col-3 m-0 p-0">
              <ul class="boxGemeos_list d-inline-block mr-5">
                <li class="boxGemeos_list_item boxGemeos_list_title">
                  Matrícula
                </li>

                <li class="boxGemeos_list_item">
                  <strong>
                    {{ gemeo.matricula ? gemeo.matricula : 'Não declarado' }}
                  </strong>
                </li>
              </ul>
            </div>
          </div>

          <div class="d-inline-block">
            <button class="btn btn-sm btn-danger mr-2"
                    type="button"
                    @click="removeGemeo(gemeo)">
              Excluir
            </button>
            <button class="btn btn-sm btn-primary"
                    type="button"
                    @click="editGemeo(gemeo, ind)">
              Editar
            </button>
          </div>
        </div>
      </div>
    </div>

    <button v-if="gemeos.valid"
            class="btn btn-sm btn-outline-primary btn-block btn-add-gemeo mt-2 mb-4"
            type="button"
            @click="showModal = true">
      <IconSvg class="icon-add mr-1"
               icon="add" />
      Adicionar gêmeo
    </button>
  </form>
</template>

<script>
  //constants
  import objSwal from '@/constants/swalValues'

  //components
  import FormGemeos from './FormGemeos'
  import Swal from 'sweetalert2'

  /* filters */
  import { maskDnv } from "@/filters/filters"
 
  export default {
    name: 'BoxFormGemeos',
    components: {
      FormGemeos
    },
    props: {
      propGemeosCrc: { type: [Boolean, Number], default: () => false },
      lista: { type: Array, default: () => ([]) },
      propMatricula: {type: String, default: null},
      propOrdemNascimento: {type: [Number, String], default: null}
    },
    inject: ['$validator'],
    data () {
      return {
        maskDnv,
        gemeos: {
          valid: 0
        },
        sendData: {
          nome: '',
          sexo: null,
          numero_declaracao_nascido_vivo: null,
          matricula: null,
          ordem_nascimento: 1
        },
        showModal: false,
        sexos: {
          'I': 'Indefinido',
          'F': 'Feminino',
          'M': 'Masculino'
        },
        ordem_nascimento_registrado: null
      }
    },
    watch: {
      lista (newObj) {
        if (newObj.length) {
          this.gemeos.valid = 1

          if (!this.propOrdemNascimento && !this.propGemeosCrc) {
            this.ordem_nascimento_registrado = ''
          }

          setTimeout(() => {
            this.$validator.validate('ordem_nascimento_registrado')
          }, 500)
        }
      },
      propOrdemNascimento () {
        this.ordem_nascimento_registrado = this.propOrdemNascimento
      },
      propGemeosCrc (flag) {
        if (flag) {
          this.gemeos.valid = 1
        }
      }
    },
    mounted () {
      this.ordem_nascimento_registrado = this.propOrdemNascimento

      if ((this.lista && this.lista.length) || this.propGemeosCrc) {
        this.gemeos.valid = 1

        if (!this.propOrdemNascimento && !this.propGemeosCrc) {
          this.ordem_nascimento_registrado = ''
        }

        setTimeout(() => {
          this.$validator.validate('ordem_nascimento_registrado')
        }, 500)
      }

    },
    methods: {
      modalChanged () {
        this.sendData = {
          nome: '',
          sexo: null,
          numero_declaracao_nascido_vivo: null,
          matricula: null,
          ordem_nascimento: 1
        }

        this.showModal = false
      },
      async changeGemeosOpt () {
        const { name } = this.$route

        const cadastroNascimento = name === 'cadastro_nascimento'

        if (this.gemeos.valid !== 1) {
          objSwal.info.title = 'Atualizar Gêmeo do Registro'
          objSwal.info.confirmButtonText = 'Desvincular Gêmeo'
          objSwal.info.showCancelButton = true
          objSwal.info.cancelButtonText = 'Não',
          objSwal.info.text = 'Deseja remover gêmeo vinculado anteriormente?'

          Swal.fire(objSwal.info).then(async resp => {
            if (resp.value) {
              if (!this.ordem_nascimento_registrado) {
                this.ordem_nascimento_registrado = null
                 
                await this.$validator.reset()
              }

              if (this.lista.length) {
                this.lista.forEach((gemeo, index) => this.$emit('removeGemeo', index))
              }

              this.$emit('cleanGemeos')
            }
          })
        } else if (!!this.gemeos.valid && !this.propGemeosCrc && !this.ordem_nascimento_registrado && !cadastroNascimento) {
          setTimeout(() => {
            this.ordem_nascimento_registrado = ''

            this.$validator.validate('ordem_nascimento_registrado')
          })
        }

        this.$emit('updateFlag', !!this.gemeos.valid)
      },
      changeOrdemNascimento () {
        const gemeo = this.lista.find(item => this.ordem_nascimento_registrado == item.ordem_nascimento)

        if (gemeo) {
          objSwal.error.title = "Já existe um gêmeo com a mesma ordem de nascimento."
          objSwal.error.text = ""
          objSwal.error.html = ""

          this.ordem_nascimento_registrado = null

          return Swal.fire(objSwal.error)
        }

        this.$emit('changeOrdemNascimento', this.ordem_nascimento_registrado)
      },
      addGemeos () {
        const gemeo = this.lista.find(item => this.sendData.ordem_nascimento == item.ordem_nascimento)

        if (gemeo || this.sendData.ordem_nascimento === parseInt(this.ordem_nascimento_registrado)) {
          objSwal.error.title = "Já existe um gêmeo com a mesma ordem de nascimento."
          objSwal.error.text = ""
          objSwal.error.html = ""

          return Swal.fire(objSwal.error)
        }

        this.$validator.validateAll().then(res => {
          const {errors: {items}} = this.$validator

          const ordemNascimento = items.findIndex(item => item.field === 'ordem_nascimento_registrado')

          const valid = items.length === 1 && ordemNascimento !== -1

          if ((res && !items.length) || valid) {
            if (this.sendData.matricula) {
              this.sendData.matricula = this.sendData.matricula.replace(/\ /g,'')
            }

            if (this.sendData.dnv) {
              this.sendData.dnv = this.sendData.dnv.replace(/\-/g,'')
            }

            this.$emit('addGemeo', this.sendData)

            this.sendData = {
              nome: '',
              sexo: null,
              numero_declaracao_nascido_vivo: null,
              matricula: null,
              ordem_nascimento: 1
            }

            this.$validator.reset()
            this.showModal = false

            objSwal.question.title = "Gêmeo adicionado com sucesso"
            objSwal.question.confirmButtonText = "Adicionar outro"
            objSwal.question.cancelButtonText = "Continuar"

            // O box shadow com o focus está trocado, então selecionamos o corfirm
            setTimeout(() => {
              const btnCancel = document.querySelector('.swal2-cancel')

              if (btnCancel) btnCancel.focus()
            }, 50)

            Swal.fire(objSwal.question).then(res => {
              const { value } = res

              if (value) {
                this.showModal = true
              } else {
                const btn = document.querySelector('.btn-add-gemeo')

                if (btn) btn.focus()
              }

              objSwal.question.title = ""
              objSwal.question.confirmButtonText = "Confirmar"
              objSwal.question.cancelButtonText = "Voltar"
            })
          }
        })
      },
      removeGemeo (val) {
        let ind = this.lista.indexOf(val)
        if (ind !== -1) this.$emit('removeGemeo', ind)
      },
      editGemeo (gemeo, index) {
        this.sendData = {
          ...gemeo,
          index
        }

        this.showModal = true
      },
      updateGemeo () {
        const duplicado = this.lista.find((gemeo, index) => {
          return this.sendData.ordem_nascimento == gemeo.ordem_nascimento && index != this.sendData.index
        })

        if (duplicado) {
          objSwal.error.title = "Já existe um gêmeo com a mesma ordem de nascimento."
          objSwal.error.text = ""
          objSwal.error.html = ""

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 300)

          return Swal.fire(objSwal.error)
        }

        this.$validator.validateAll().then(res => {
          const {errors: {items}} = this.$validator

          if (res && !items.length) {
            if (this.sendData.matricula) {
              this.sendData.matricula = this.sendData.matricula.replace(/\ /g,'')
            }

            if (this.sendData.dnv) {
              this.sendData.dnv = this.sendData.dnv.replace(/\-/g,'')
            }

            this.$emit('updateGemeo', this.sendData)
            this.modalChanged()
          }
        })
      },
      getDados (dados, edit) {
        this.sendData = dados

        if (edit) {
          this.updateGemeo()
        } else {
          this.addGemeos()
        }
      }
    },
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/exports';

  .headerTitleB2 {
    @extend %titleBox;
    background-color: $color-gray-light;
    font-size: inherit;

    &_title {
      @extend %titleBox;
      padding: 0;
    }
  }

  .boxGemeos {
    box-shadow: 0 0 pxToRem(4) 0 $color-dark;

    &_header {
      background-color: $sofiaRei-blue;

      &_title {
        font-size: pxToEm(14);
        text-transform: uppercase;
      }
    }

    &_body {
      background-color: $color-white;
    }

    &_list {
      list-style: none;
      margin: 0;
      padding: 0;

      &_title,
      &_item {
        font-size: pxToEm(14);
      }

      &_title {
        font-size: pxToEm(14);
        font-weight: 400;
        text-decoration: underline;
      }

      &_item {}
    }
  }

  .btn-add-gemeo:hover > [class*=icon-add] {
    fill: #fff !important;
  }
  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
</style>
